import { getActiveDiagram } from '../../theme';
import { SCHEMATIC_GLYPH_SIZE } from '../types';
export var S = SCHEMATIC_GLYPH_SIZE;
export var MID = S / 2;
export function stroke() {
    return getActiveDiagram().schematicStroke;
}
export function accent() {
    return getActiveDiagram().schematicResistor;
}
export function ledStroke() {
    return getActiveDiagram().schematicLedStroke;
}
export function ledFill() {
    return getActiveDiagram().schematicLedFill;
}
export function batteryAccent() {
    return getActiveDiagram().schematicBattery;
}
export function switchAccent() {
    return getActiveDiagram().schematicSwitch;
}
export function muted() {
    return getActiveDiagram().edgeMuted;
}
/** Shared lead lines left/right into the body. */
export function addLeads(app, g, y) {
    if (y === void 0) { y = MID; }
    g.add(app.line({ x: 6, y: y, x2: 6, y2: 0, stroke: stroke(), strokeWidth: 2, lineCap: 'round', listening: false }));
    g.add(app.line({ x: 36, y: y, x2: 6, y2: 0, stroke: stroke(), strokeWidth: 2, lineCap: 'round', listening: false }));
}
export function addPoly(app, g, points, sw) {
    if (sw === void 0) { sw = 2.1; }
    g.add(app.polyline({
        points: points,
        fill: null,
        stroke: stroke(),
        strokeWidth: sw,
        lineCap: 'round',
        lineJoin: 'round',
        listening: false,
    }));
}
export function addLine(app, g, x, y, dx, dy, sw, color) {
    if (sw === void 0) { sw = 2; }
    g.add(app.line({ x: x, y: y, x2: dx, y2: dy, stroke: color !== null && color !== void 0 ? color : stroke(), strokeWidth: sw, lineCap: 'round', listening: false }));
}
/** Circle helper — `(x, y)` is the center (library Circle uses top-left). */
export function addCircle(app, g, x, y, r, fill, sw) {
    if (fill === void 0) { fill = null; }
    if (sw === void 0) { sw = 1.75; }
    g.add(app.circle({
        x: x - r,
        y: y - r,
        radius: r,
        fill: fill,
        stroke: stroke(),
        strokeWidth: sw,
        listening: false,
    }));
}
export function addText(app, g, text, x, y, size) {
    if (size === void 0) { size = 8; }
    g.add(app.text({
        text: text,
        x: x,
        y: y,
        fontSize: size,
        fontWeight: '700',
        fontFamily: getActiveDiagram().fontFamily,
        fill: stroke(),
        listening: false,
    }));
}
export function addBox(app, g, x, y, w, h, label) {
    g.add(app.roundedRect({
        x: x,
        y: y,
        width: w,
        height: h,
        cornerRadius: 3,
        fill: getActiveDiagram().schematicFill,
        stroke: stroke(),
        strokeWidth: 1.75,
        listening: false,
    }));
    if (label) {
        var approx = label.length * 4.2;
        addText(app, g, label, x + Math.max(2, (w - approx) / 2), y + h / 2 + 3, 8);
    }
}
export function arrowHead(app, g, x, y, dx, dy, size) {
    if (size === void 0) { size = 4; }
    var len = Math.hypot(dx, dy) || 1;
    var ux = dx / len;
    var uy = dy / len;
    var px = -uy;
    var py = ux;
    g.add(app.polygon({
        points: [
            x,
            y,
            x - ux * size + px * size * 0.55,
            y - uy * size + py * size * 0.55,
            x - ux * size - px * size * 0.55,
            y - uy * size - py * size * 0.55,
        ],
        fill: stroke(),
        stroke: null,
        listening: false,
    }));
}
